import React, { useMemo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function SuiteEmployeePicker({
  employees = [], value, onValueChange, className = "w-64", triggerClassName = "",
  testId, includeAll = false, allValue = "__all__", allLabel = "Tutti i dipendenti",
  placeholder = "Seleziona", renderLabel,
}) {
  const realEmployees = useMemo(() => employees.filter((employee) => employee?.id), [employees]);
  const currentIndex = realEmployees.findIndex((employee) => employee.id === value);
  const select = (index) => {
    const employee = realEmployees[index];
    if (employee) onValueChange(employee.id);
  };

  return (
    <div className={`inline-flex items-center rounded-md border border-suite-neutral-200 bg-white ${className}`}>
      <button type="button" className="h-9 w-9 shrink-0 grid place-items-center text-suite-neutral-600 hover:bg-suite-neutral-50 disabled:opacity-30"
        onClick={() => select(currentIndex - 1)} disabled={currentIndex <= 0}
        aria-label="Dipendente precedente" data-testid={testId ? `${testId}-previous` : undefined}>
        <ChevronLeft size={16} />
      </button>
      <Select value={value || ""} onValueChange={onValueChange}>
        <SelectTrigger className={`h-9 min-w-0 flex-1 rounded-none border-y-0 border-suite-neutral-200 shadow-none focus:ring-0 ${triggerClassName}`} data-testid={testId}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {includeAll && <SelectItem value={allValue}>{allLabel}</SelectItem>}
          {realEmployees.map((employee) => (
            <SelectItem key={employee.id} value={employee.id}>
              {renderLabel ? renderLabel(employee) : [employee.last_name, employee.first_name].filter(Boolean).join(" ")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <button type="button" className="h-9 w-9 shrink-0 grid place-items-center text-suite-neutral-600 hover:bg-suite-neutral-50 disabled:opacity-30"
        onClick={() => select(currentIndex + 1)} disabled={currentIndex < 0 || currentIndex >= realEmployees.length - 1}
        aria-label="Dipendente successivo" data-testid={testId ? `${testId}-next` : undefined}>
        <ChevronRight size={16} />
      </button>
    </div>
  );
}
